import { createSlice, createAsyncThunk, type PayloadAction } from '@reduxjs/toolkit';
import sendRequest from '../../services/service';

export interface Campaign {
  id: string;
  name: string;
  [key: string]: any;
}

interface CampaignState {
  campaigns: Campaign[];
}

const initialState: CampaignState = {
  campaigns: [],
};

export const fetchCampaignsList = createAsyncThunk('campaigns/fetchList', async (reportAccessToken: string) => {
  const response = await sendRequest.get({
    url: 'Campaigns/search',
    data: {
      pageSize: 100,
      pageNumber: 1,
      StateTypes: ['Running'],
    },
    reportAccessToken,
    skipUrlOrganizationId: true,
  });
  return response.result || [];
});

const campaignSlice = createSlice({
  name: 'campaigns',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCampaignsList.fulfilled, (state, action: PayloadAction<Campaign[]>) => {
      state.campaigns = action.payload;
    });
  },
});

export default campaignSlice.reducer;
